module.exports = __webpack_public_path__ + "img/banker-green-promotions.677de137.png";